import { Box, CircularProgress, Typography } from "@mui/material";

import ChoicePills from "./ChoicePills";
import StepBlock from "./StepBlock";

const ITEM_OPTIONS = [
  { value: "duration", label: "累計時長" },
  { value: "score", label: "最佳成績" },
];

function skillLabel(skill) {
  const name = skill?.name_zh || skill?.name_en || skill?.code || "";
  const code = skill?.code || "";
  if (name && code && name !== code) {
    return `${name} ${code}`;
  }
  return name || code;
}

export default function ItemSelection({ item, skillCode, skills, skillsLoading, onChange }) {
  const selectItem = (nextItem) => {
    if (nextItem === "duration") {
      onChange({ item: "duration", skillCode: "all" });
      return;
    }
    onChange({
      item: "score",
      skillCode: skillCode && skillCode !== "all" ? skillCode : "",
    });
  };

  return (
    <>
      <StepBlock number="3" title="排名項目" subtitle="右邊顯示的數字">
        <ChoicePills options={ITEM_OPTIONS} value={item} onChange={selectItem} />
      </StepBlock>

      {item === "score" ? (
        <StepBlock number="4" title="活動" subtitle="最佳成績須選擇一項活動">
          <Box
            sx={{
              border: "1px solid #dbe3ee",
              borderRadius: 2,
              maxHeight: 280,
              overflowX: "hidden",
              overflowY: "auto",
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 1.25,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #eef2f6",
                color: "#6b7280",
              }}
            >
              <Typography variant="body2">請選擇活動</Typography>
              <Typography variant="body2">▴</Typography>
            </Box>

            {skillsLoading ? (
              <Box sx={{ px: 2, py: 2 }}>
                <CircularProgress size={18} />
              </Box>
            ) : null}

            {!skillsLoading && (!skills || skills.length === 0) ? (
              <Typography variant="body2" sx={{ px: 2, py: 2, color: "#6b7280" }}>
                未有活動
              </Typography>
            ) : null}

            {(skills || []).map((skill) => {
              const selected = skill.code === skillCode;
              return (
                <Box
                  key={skill.code}
                  onClick={() => onChange({ item: "score", skillCode: skill.code })}
                  sx={{
                    px: 2,
                    py: 1.25,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    bgcolor: selected ? "#e8f1ff" : "#fff",
                    "&:hover": { bgcolor: selected ? "#e8f1ff" : "#f8fafc" },
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: selected ? 700 : 500 }}>
                    {skillLabel(skill)}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#6b7280", ml: 2, flexShrink: 0 }}>
                    {skill.unit || ""}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </StepBlock>
      ) : null}
    </>
  );
}
